import { useMemo } from "react";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useEntradaProdutosListaViewModel } from "../../viewModels/entradaProdutos_lista_view_model";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { Header } from "./components/header";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { GenerateEntradaProdutosColumns } from "./columns/entrada_produtos";
import { EntradaProduto } from "../../../domain/models/entrada_produtos_lista";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { EntradaProdutoModal } from "./components/entradaProduto_modal";
import { EntradaProdutoMultiModal } from "./components/entradaProduto_multi_modal";
import { ReportModal } from "./components/report_modal";
import { ProdutoServicoDrawer } from "../../../../../common/components/drawers_api/drawers/produto_servico_drawer";
import { ImportXmlModal } from "./components/import_xml_modal";
import { FornecedorDrawer } from "../../../../../common/components/drawers_api/drawers/fornecedor_drawer";

import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

export const EntradaProdutosLista = () => {
  const viewModel = useEntradaProdutosListaViewModel();
  const EntradaProdutosListalColumns = useMemo(() => {
    return GenerateEntradaProdutosColumns({
      onActionEditar: viewModel.handleCadastroEntradaOpenState,
      onActionDeletar: viewModel.handleDeleteModalOpenState,
    });
  }, [
    viewModel.handleCadastroEntradaOpenState,
    viewModel.handleDeleteModalOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[12rem]">
                <PrimaryButton
                  aria-haspopup="true"
                  onClick={() => viewModel.handleReportModalOpenState(true)}
                  buttonColor="yellow">
                  Relatórios
                </PrimaryButton>
              </div>
              <div className="w-[180px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroEntradaOpenState(null, true)}>
                  Incluir Item
                </PrimaryButton>
              </div>
              <div className="w-[220px] ">
                <PrimaryButton
                  buttonColor="secondary"
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroEntradaMultiOpenState(true)}>
                  Incluir Múltiplas Entradas
                </PrimaryButton>
              </div>
              <div className="w-[220px] ">
                <PrimaryButton
                  buttonColor="secondary"
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleImportXmlModalOpenState(true)}>
                  Importar arquivo XML
                </PrimaryButton>
              </div>
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Controle de Estoque
            </Link>
            <Typography className="text-primary-green">
              Entrada de Produtos
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Entrada de Produtos</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>

          <Header
            onClearFilters={viewModel.handleClearFilters}
            handleFornecedorChange={viewModel.handleFornecedorChange}
            FornecedorPesquisa={viewModel.filters.FornecedorPesquisa}
            centroDeCusto={viewModel.filters.centroDeCusto}
            centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
            handleCentroDeCusto={viewModel.handleCentroDeCustoChange}
            dataEntradaAte={viewModel.filters.dataEntradaAte}
            dataEntradaDe={viewModel.filters.dataEntradaDe}
            handleDataEntradaRangeChange={viewModel.handleDataReceberRangeChange}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.pesquisa}
            ordemCompra={viewModel.filters.ordemCompra}
            ordemComprasDropdown={viewModel.ordemComprasDropdown}
            handleOrdemCompraChange={viewModel.handleOrdemCompraChange}
            handleProdutorChange={viewModel.handleProdutorChange}
            ProdutorPesquisa={viewModel.filters.ProdutoPesquisa}
          />

          <StyledDataGrid
            tableName="Entrada_Produtos_lista"
            disableColumnMenu={false}
            getRowId={(row: EntradaProduto) => row.IdEntradaProduto}
            columns={EntradaProdutosListalColumns}
            loading={viewModel.loading}
            rows={viewModel.entradaProdutoLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pinnedColumns={{
              right: ["IdEntradaProduto"],
            }}
            autoHeight={true}
            textSize="medio"
            getRowHeight={() => "auto"}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

      <ProdutoServicoDrawer
        saving={viewModel.saving}
        state={viewModel.produtoServicoDrawerState}
      />

      <FornecedorDrawer
        saving={viewModel.saving}
        state={viewModel.fornecedorDrawerState}
        centrosCustoDropdown={viewModel.centroDeCustoLista}
      />

      <EntradaProdutoModal
        loading={viewModel.loading}
        onClose={() => viewModel.setEntradaModal(false)}
        onSubmit={viewModel.handleEntradaProdutoSubmit}
        open={viewModel.entradaModal}
        saving={viewModel.saving}
        dropdownProdutosServicos={viewModel.produtoServicoDropdown ?? []}
        selectedEntradaProduto={viewModel.selectedEntradaProduto}
        centroCustoLista={viewModel.centroDeCustoLista}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)} />

      <EntradaProdutoMultiModal
        loading={viewModel.loading}
        onClose={() => viewModel.setEntradaMultiModal(false)}
        onSubmit={viewModel.handleEntradaProdutoMultiSubmit}
        onUpdate={viewModel.handleUpdateMutiTodos}
        open={viewModel.entradaMultiModal}
        saving={viewModel.saving}
        selectedEntradaProduto={viewModel.selectedEntradaProduto}
        centroCustoLista={viewModel.centroDeCustoLista}
        handleProdutosServicosQueryChange={viewModel.handleProdutosServicosQueryChange}
        produtosServicosDropDown={viewModel.produtoServicoDropdown ?? []}
        selectedProdutosServicosQuery={viewModel.selectedProdutosServicosQuery}
        entradaProduto={viewModel.produtoIdSessaoLista}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)}
        OnActionCentroCustoChange={viewModel.handleCentroCustoChange}
        fornecedorLista={viewModel.fornecedorLista ?? []}
        OnActionQuantidadeChange={viewModel.handleQuantidadeChange}
        OnActionFornecedorChange={viewModel.handleFornecedorMChange}
        OnActionValorChange={viewModel.handleValorChange}
        onNewProdutoServico={viewModel.handleNewProdutoServico}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <DeleteDialog
        open={viewModel.deleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirma} />

      <ReportModal
        saving={viewModel.saving}
        selectedCentroCustoQuery={viewModel.selectedCentroCustoQuery}
        centroCustoDropDown={viewModel.centroDeCustoLista}
        handleCentroCustoQueryChange={viewModel.handleCentroCustoQueryChange}
        open={viewModel.openReportModal}
        reactHookForm={viewModel.hookForm}
        onSubmit={viewModel.handleSubmitReport}
        onClose={() => viewModel.handleReportModalOpenState(false)}
        handleProdutosServicosQueryChange={viewModel.handleReportProdutosServicosQueryChange}
        selectedProdutosServicosQuery={viewModel.selectedReportProdutosServicosQuery}
        fornecedorDropDown={viewModel.fornecedorLista}
        handleFornecedorQueryChange={viewModel.handleFornecedorQueryChange}
        selectedFornecedorQuery={viewModel.selectedFornecedorQuery}
        produtosServicosDropDown={viewModel.produtoServicoDropdown ?? []}
      />

      <ImportXmlModal
        open={viewModel.importXmlModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        centroCustoDropdown={viewModel.centroDeCustoLista}
        fornecedoresDropdown={viewModel.fornecedorLista}
        produtosServicosDropdown={viewModel.produtoServicoDropdown}
        onClose={() => viewModel.handleImportXmlModalOpenState(false)}
        onNewProduct={viewModel.handleImportXmlNewProduct}
        onNewFornecedor={viewModel.handleImportXmlNewFornecedor}
        onImportXmlSubmit={viewModel.handleImportXmlSubmit}
      />

    </>
  )
};
